/*eslint react-hooks/exhaustive-deps: "off"*/
import {useEffect, useState} from "react";
import {VWORLD_APIKEY} from "../../Constants";
import useCancelableAxiosGet from "../../utils/hooks/useCancelableAxiosGet";
import {getApiHost, makeQueryString} from "../../utils";


function useVworldCityType(setCityType) {
  const {
    setIsEnable,
    setUrl,
    setConfig,
    response,
  } = useCancelableAxiosGet();

  const [position, setPosition] = useState();

  useEffect(() => {
    if ( position ) {
      const { latitude, longitude } = position;

      const params = makeQueryString({
        lon: longitude,
        lat: latitude
      });
      const url = getApiHost() + '/gis/getLocationClsNm.json';
      const requestUrl = url + '?' + params;
      setUrl(requestUrl);
    }
  }, [position]);

  useEffect(() => {
    console.log(response);
    if ( response ) {
      const { data: {cls_nm_detail} } = response;
      if ( cls_nm_detail ) {
        setCityType(cls_nm_detail);
        return;
      }
    }
    setCityType(null);
  }, [response]);

  /*

  useEffect(() => {
    if ( position ) {
      const { latitude, longitude } = position;

      const proxyUrl = getApiHost() + '/gis/proxy.do';
      setUrl(proxyUrl);

      const params = makeQueryString({
        service: 'data',
        request: 'GetFeature',
        data: 'LT_C_UQ111',
        key: VWORLD_APIKEY,
        domain: window.location.origin,
        crs: 'EPSG:4326',
        geomFilter: `point(${longitude} ${latitude})`
      });
      const url = 'http://api.vworld.kr/req/data';
      const requestUrl = url + '?' + params;
      setConfig({ params: { url: requestUrl } });
    }
  }, [position]);

  useEffect(() => {
    if ( response ) {
      const { data: {response: {result}} } = response;
      if ( result ) {
        const {featureCollection: {features: [{properties}]}} = result;
        const { uname: cityType } = properties;
        setCityType(cityType);
        return;
      }
    }
    setCityType(null);
  }, [response]);

   */

  return {
    setIsEnable,
    setPosition,
  };
}

export default useVworldCityType;
